<template>
    <div class="props-group">
        <el-form-item label="名称" prop="name" :rules="rules">
          <el-input v-focus v-model="component.name" placeholder="请输入控件名称" maxlength="20" :key="component.id"/>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'attr-name',
  props: ['component'],
  data () {
    return {
      rules: [
        { required: true, message: '请输入控件名字', trigger: 'blur' },
        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/name.vue